<div class="create-password-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <!-- Success state -->
  @if (activationSuccess()) {
    <div class="create-password-card">
      <div class="card-content card-content--centered success-content">
        <!-- Animated success icon -->
        <div class="success-icon-wrapper">
          <svg
            class="success-check"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <!-- Text -->
        <div class="card-header">
          <h1 class="card-title">{{ 'create-password.success-screen-title' | translate }}</h1>
          <p class="card-subtitle">{{ 'create-password.success-screen-subtitle' | translate }}</p>
          <p class="card-subtitle">{{ 'create-password.success-screen-redirect' | translate }}</p>
        </div>

        <!-- CTA Button -->
        <button type="button" class="btn-primary" (click)="goToApp()">
          {{ 'create-password.success-screen-cta' | translate }}
        </button>

        <!-- Countdown -->
        <p class="countdown-text">
          {{ 'create-password.success-screen-countdown' | translate: { count: redirectCountdown() } }}
        </p>
      </div>
    </div>
  } @else if (isExpired()) {
    <div class="create-password-card">
      <div class="card-content card-content--centered">
        <div class="icon-wrapper icon-wrapper--expired">
          <svg
            class="icon-clock"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <div class="card-header">
          <h1 class="card-title">{{ 'create-password.expired-title' | translate }}</h1>
          @if (email) {
            <p class="card-subtitle">
              {{ 'create-password.expired-subtitle' | translate }}
              <span class="email-highlight">{{ email }}</span>
              {{ 'create-password.expired-subtitle-end' | translate }}
            </p>
          }
          <p class="card-subtitle">{{ 'create-password.expired-description' | translate }}</p>
        </div>
        @if (email) {
          <button
            type="button"
            class="btn-resend"
            [ngClass]="{
              'btn-resend--sent': resendState === 'sent',
              'btn-resend--cooldown': cooldown() > 0 && resendState === 'idle',
            }"
            [disabled]="resendState === 'sending'"
            (click)="handleResend()"
          >
            @if (resendState === 'sending') {
              <svg
                class="btn-loader"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="12" y1="2" x2="12" y2="6"></line>
                <line x1="12" y1="18" x2="12" y2="22"></line>
                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                <line x1="2" y1="12" x2="6" y2="12"></line>
                <line x1="18" y1="12" x2="22" y2="12"></line>
                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
              </svg>
              <span>{{ 'create-password.sending' | translate }}</span>
            } @else if (resendState === 'sent') {
              <svg
                class="btn-check"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>{{ 'create-password.email-sent' | translate }}</span>
            } @else if (cooldown() > 0) {
              <svg
                class="btn-mail"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
              </svg>
              <span>{{ 'create-password.resend-cooldown' | translate: { count: cooldown() } }}</span>
            } @else {
              <svg
                class="btn-mail"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
              </svg>
              <span>{{ 'create-password.receive-new-link' | translate }}</span>
            }
          </button>
          @if (resendState === 'sent' || (cooldown() > 0 && resendState === 'idle')) {
            <p class="feedback-text">{{ 'create-password.check-inbox' | translate }}</p>
          }
        }
        <button type="button" class="back-link" (click)="goBackToEmail()">
          <svg
            class="back-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <span>{{ 'create-password.back-to-login' | translate }}</span>
        </button>
      </div>
    </div>
  } @else {
    <!-- Create password form -->
    <div class="create-password-card">
      <form class="card-content card-content--form" (ngSubmit)="onSubmit()">
        <div class="card-header">
          <div class="lock-icon-wrapper">
            <svg
              class="lock-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <h1 class="card-title">{{ 'create-password.title' | translate }}</h1>
          <p class="card-subtitle">
            {{ 'create-password.subtitle' | translate }}
            @if (email) {
              <span class="email-highlight">{{ email }}</span>
            }
          </p>
        </div>

        <div class="password-field">
          <label class="field-label">{{ 'create-password.password-label' | translate }}</label>
          <div class="input-wrapper">
            <input
              type="{{ showPassword() ? 'text' : 'password' }}"
              [value]="password()"
              (input)="onPasswordInput($any($event.target).value)"
              class="input-password"
              [placeholder]="'create-password.placeholder' | translate"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="toggle-password"
              (click)="toggleShowPassword()"
              [attr.aria-label]="showPassword() ? ('create-password.hide' | translate) : ('create-password.show' | translate)"
            >
              @if (showPassword()) {
                <img class="toggle-icon" src="assets/images/hide-password-icon.svg" alt="" />
              } @else {
                <img class="toggle-icon" src="assets/images/show-password-icon.svg" alt="" />
              }
            </button>
          </div>

          @if (hasInteracted() && password().length > 0) {
            <div class="strength-bar">
              <span class="strength-label">{{ 'create-password.strength-label' | translate }}</span>
              <span class="strength-value" [style.color]="strength().color">
                {{ strength().labelKey ? (strength().labelKey | translate) : '' }}
              </span>
            </div>
            <div class="strength-segments">
              @for (i of [1, 2, 3]; track i) {
                <div class="segment" [style.background-color]="i <= strength().level ? strength().color : 'var(--basic-300)'"></div>
              }
            </div>
          }

          @if (hasInteracted()) {
            <div class="requirements-list">
              <div class="requirement-item" [class.requirement-item--met]="requirements()[0].met">
                @if (requirements()[0].met) {
                  <img class="requirement-icon" src="assets/images/icon-green-checkmark-circle.svg" alt="" />
                } @else {
                  <img class="requirement-icon" src="assets/images/icon-radio-button-off.svg" alt="" />
                }
                <span>{{ requirements()[0].labelKey | translate }}</span>
              </div>
              <div class="requirements-grid">
                @for (r of requirements().slice(1, 3); track r.id) {
                  <div class="requirement-item" [class.requirement-item--met]="r.met">
                    @if (r.met) {
                      <img class="requirement-icon" src="assets/images/icon-green-checkmark-circle.svg" alt="" />
                    } @else {
                      <img class="requirement-icon" src="assets/images/icon-radio-button-off.svg" alt="" />
                    }
                    <span>{{ r.labelKey | translate }}</span>
                  </div>
                }
              </div>
              <div class="requirements-grid">
                @for (r of requirements().slice(3, 5); track r.id) {
                  <div class="requirement-item" [class.requirement-item--met]="r.met">
                    @if (r.met) {
                      <img class="requirement-icon" src="assets/images/icon-green-checkmark-circle.svg" alt="" />
                    } @else {
                      <img class="requirement-icon" src="assets/images/icon-radio-button-off.svg" alt="" />
                    }
                    <span>{{ r.labelKey | translate }}</span>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="submit-row">
          <button
            type="submit"
            class="btn-primary"
            [class.btn-primary--disabled]="!allMet() || isSubmitting()"
            [disabled]="!allMet() || isSubmitting()"
          >
            @if (isSubmitting()) {
              <svg
                class="btn-loader"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="12" y1="2" x2="12" y2="6"></line>
                <line x1="12" y1="18" x2="12" y2="22"></line>
                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                <line x1="2" y1="12" x2="6" y2="12"></line>
                <line x1="18" y1="12" x2="22" y2="12"></line>
                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
              </svg>
            }
            <span>{{ isSubmitting() ? ('create-password.activating' | translate) : ('create-password.submit' | translate) }}</span>
          </button>
        </div>
      </form>
    </div>
  }
</div>
